import axios from "axios";
import { CareersActions } from "./careersAction";
import { showSuccessSnackbar } from "../../snackBar/snackBar.action";

const getAdminURL = (state) => {
  return state.environnment.environmentLists.adminBaseURL;
};

export const createCareersAsync = (
  detail,
  setSubmitting,
  resetForm,
  redirectBack
) => {
  return async (dispatch, getState) => {
    try {
      const adminBaseURL = getAdminURL(getState());
      dispatch(CareersActions.createCareersStart());
      let { data } = await axios({
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/webcluescareers/create`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: detail,
      });
      if (data.code === 200 && data.status) {
        dispatch(CareersActions.createCareersSuccess(data.data));
        setSubmitting(false);
        resetForm();
        redirectBack();
        return dispatch(showSuccessSnackbar("success", data.message, 3000));
      }
      dispatch(CareersActions.createCareersError());
      dispatch(showSuccessSnackbar("error", data.message, 3000));
      setSubmitting(false);
    } catch (error) {
      dispatch(CareersActions.createCareersError());
      setSubmitting(false);
      resetForm();
      dispatch(
        showSuccessSnackbar("error", "Error while fetching Data.", 3000)
      );
    }
  };
};

export const getAllCareersAsync = (searchBy, searchText) => {
  return async (dispatch, getState) => {
    try {
      const adminBaseURL = getAdminURL(getState());
      dispatch(CareersActions.getAllCareers());
      let { skip, limit } = getState().webcluescareers;
      let { data } = await axios({
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/webcluescareers/getAll?skip=${skip}&limit=${limit}&column=${searchBy}&search=${searchText}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (data.code === 200) {
        return dispatch(CareersActions.getAllCareersSuccess(data.data));
      }
      dispatch(CareersActions.getAllCareersError());
      dispatch(showSuccessSnackbar("error", data.message, 3000));
    } catch (error) {
      console.log("Error: ", error);
      dispatch(CareersActions.getAllCareersError());
      dispatch(
        showSuccessSnackbar("error", "Error while fetching Data.", 3000)
      );
    }
  };
};

export const getCareersDetailAsync = (id) => {
  return async (dispatch, getState) => {
    try {
      const adminBaseURL = getAdminURL(getState());
      dispatch(CareersActions.getCareersDetail());
      let { data } = await axios({
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/webcluescareers/getDetail/${id}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (data.code === 200) {
        return dispatch(CareersActions.getCareersDetailSuccess(data.data));
      }
      dispatch(CareersActions.getCareersDetailError());
      dispatch(showSuccessSnackbar("error", data.message, 3000));
    } catch (error) {
      dispatch(CareersActions.getCareersDetailError());
      dispatch(
        showSuccessSnackbar("error", "Error while fetching Data.", 3000)
      );
    }
  };
};

export const updateCareersAsync = (
  values,
  setSubmitting,
  resetForm,
  redirectBack
) => {
  return async (dispatch, getState) => {
    try {
      const adminBaseURL = getAdminURL(getState());
      //let { _id } = getState().auth.user;
      let { selectedCareers } = getState().webcluescareers;
      dispatch(CareersActions.updateCareersStart());
      const { data } = await axios({
        method: "PUT",
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/webcluescareers/update/${selectedCareers._id}`,
        headers: {
          "Content-Type": "application/json",
        },
        data: values,
      });
      if (data.code === 200 && data.status) {
        dispatch(CareersActions.updateCareersSuccess(data.data));
        setSubmitting(false);
        resetForm();
        redirectBack();
        return dispatch(showSuccessSnackbar("success", data.message, 3000));
      }
      dispatch(CareersActions.updateCareersError());
      setSubmitting(false);
      return dispatch(showSuccessSnackbar("error", data.message, 3000));
    } catch (error) {
      dispatch(CareersActions.updateCareersError(error));
      setSubmitting(false);
      resetForm();
      dispatch(showSuccessSnackbar("error", "Error while fetching data", 3000));
    }
  };
};

export const deleteCareersAsync = (id) => {
  return async (dispatch, getState) => {
    try {
      const adminBaseURL = getAdminURL(getState());
      dispatch(CareersActions.deleteCareersStart());
      let { data } = await axios({
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/webcluescareers/remove/${id}`,
        method: "delete",
      });
      if (data.code === 200) {
        dispatch(CareersActions.deleteCareersSuccess(data.data));
        return dispatch(showSuccessSnackbar("success", data.message, 3000));
      }
      dispatch(CareersActions.deleteCareersError());
      return dispatch(showSuccessSnackbar("error", data.message, 3000));
    } catch (error) {
      console.log("Error: ", error);
      dispatch(CareersActions.deleteCareersError());
      dispatch(
        showSuccessSnackbar(
          "error",
          "Error while updating.Please try again after sometime..",
          3000
        )
      );
    }
  };
};

export const careersListAsync = () => {
  return async (dispatch, getState) => {
    try {
      const adminBaseURL = getAdminURL(getState());
      dispatch(CareersActions.getCareersListStart());
      let { data } = await axios({
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/webcluescareers/careersList`,
        method: "get",
      });
      if (data.code === 200) {
        dispatch(CareersActions.getCareersListSuccess(data.data));
        // return dispatch(showSuccessSnackbar("success", data.message, 3000));
      } else {
        dispatch(CareersActions.getCareersListError());
        return dispatch(showSuccessSnackbar("error", data.message, 3000));
      }
    } catch (error) {
      console.log("Error: ", error);
      dispatch(CareersActions.getCareersListError());
      dispatch(
        showSuccessSnackbar(
          "error",
          "Error while updating.Please try again after sometime..",
          3000
        )
      );
    }
  };
};

export const getWebCareersCityListAsync = () => {
  return async (dispatch, getState) => {
    try {
      const adminBaseURL = getAdminURL(getState());
      dispatch(CareersActions.getWebCareersCityList()); // set loading state, optional

      const { data } = await axios({
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/webcluescareersCity/getCareersCityList`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (data.code === 200) {
        dispatch(CareersActions.getWebCareersCityListSuccess(data.data));
      } else {
        dispatch(CareersActions.getWebCareersCityListError());
        dispatch(showSuccessSnackbar("error", data.message, 3000));
      }
    } catch (error) {
      console.error("Web Careers City List Fetch Error:", error);
      dispatch(CareersActions.getWebCareersCityListError());
      dispatch(
        showSuccessSnackbar(
          "error",
          "Error while fetching Web Careers City.",
          3000
        )
      );
    }
  };
};

export const getCareersLogsAsync = (careersId) => {
  return async (dispatch, getState) => {
    try {
      const adminBaseURL = getAdminURL(getState());
      dispatch(CareersActions.getCareersLogs());
      const { data } = await axios({
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/webcluescareers/getLogs/${careersId}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (data.code === 200) {
        return dispatch(CareersActions.getCareersLogsSuccess(data.data));
      }
      dispatch(CareersActions.getCareersLogsError());
      dispatch(showSuccessSnackbar("error", data.message, 3000));
    } catch (error) {
      dispatch(CareersActions.getCareersLogsError());
      dispatch(
        showSuccessSnackbar("error", "Error while fetching Data.", 3000)
      );
    }
  };
};
